// extracted by mini-css-extract-plugin
export default {"dialog":"KOcQIqaFcL0rheCE"};